"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._RemoveFitpayPaymentOptions = _RemoveFitpayPaymentOptions;
exports._RemoveAllPaymentOptions = _RemoveAllPaymentOptions;
var module_mapping_1 = require("@src/const/module.mapping");
var cash_dom_1 = __importDefault(require("cash-dom"));
function _RemoveFitpayPaymentOptions($container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)(document.body); }
    // Remove the payment tabs menu
    var paymentTabs = $container.find("[class='payment-tabs w-tab-menu']");
    if (paymentTabs.length > 0) {
        paymentTabs.remove();
    }
    // Select the tabs
    var sepaTab = $container.find("[data-w-tab='Sepa']");
    var fitpayTab = $container.find("[data-w-tab='PayPal']");
    // Remove the Fitpay tab
    if (fitpayTab.length) {
        fitpayTab.remove();
    }
    // Activate the Sepa tab
    if (sepaTab.length) {
        sepaTab.addClass('w--tab-active');
    }
    // remove containers
    var paymentContainer = $container.find("[data-ref=\"".concat(module_mapping_1._MembershipCompletionReferences.fitpayCheckout.uid, "\"]"));
    if (paymentContainer.length > 0) {
        paymentContainer.remove();
    }
    var paymentExpressContainer = $container.find("[data-ref=\"".concat(module_mapping_1._MembershipCompletionReferences.fitpayExpressCheckout.uid, "\"]"));
    if (paymentExpressContainer.length > 0) {
        paymentExpressContainer.remove();
    }
    var disabledFitbuyContainer = $container.find("[data-ref=\"".concat(module_mapping_1._MembershipCompletionReferences.removeOnDisabledFitpay.uid, "\"]"));
    if (disabledFitbuyContainer.length > 0) {
        disabledFitbuyContainer.remove();
    }
}
function _RemoveAllPaymentOptions(moduleRefs) {
    var expressContainer = (0, cash_dom_1.default)("[data-ref=\"".concat(module_mapping_1._MembershipCompletionReferences.fitpayExpressCheckout.uid, "\"]"));
    if (expressContainer.length) {
        expressContainer.remove();
    }
    var disabledFitbuyContainer = (0, cash_dom_1.default)("[data-ref=\"".concat(module_mapping_1._MembershipCompletionReferences.removeOnDisabledFitpay.uid, "\"]"));
    if (disabledFitbuyContainer.length) {
        disabledFitbuyContainer.remove();
    }
    var paymentSwitcher = (0, cash_dom_1.default)("[data-ref=\"".concat(module_mapping_1._MembershipCompletionReferences.fitpayPaymentSwitcher.uid, "\"]"));
    if (paymentSwitcher.length) {
        paymentSwitcher.html('');
        var successfulMsg = (0, cash_dom_1.default)("[data-ref=\"".concat(module_mapping_1._MembershipCompletionReferences.fitpayPaymentSuccessful.uid, "\"]"));
        if (successfulMsg.length) {
            paymentSwitcher.append(successfulMsg.html());
        }
    }
}
